import React from 'react';

const Footer = () => {
	const contactPhone = window.APP_CONFIG.CONTACT_PHONE;
	const email = localStorage.getItem('brand_email');
	const href = `mailto: ${email}`;
	const privacyPolicyHref = `https://www.securityfirstflorida.com/privacy-and-cookies-policy/`;

	return (
		<div className="flex flex-col text-sfi-blue text-center py-5 font-bold">
			<span className="text-base md:text-xl">Questions? {contactPhone}</span>
			<span className="text-xs md:text-sm">
				<a href={href}>{email}</a>
			</span>
			<span className="text-xs md:text-sm">Monday–Friday 8:00 am–7:00 pm ET</span>
			<span className="text-xs md:text-sm">
				<a href={privacyPolicyHref}>Privacy Policy</a>
			</span>
		</div>
	);
};

export default Footer;
